/* heimatkinner – Korb-Animation + Kaufbereich (Abschnitt „heimatkinner Korb + Kauf“) */
(() => {
  const hero = document.querySelector("[data-hk-hero]");
  if (!hero || hero.dataset.ready) return;
  hero.dataset.ready = "1";

  const q = s => hero.querySelector(s);
  const qa = s => [...hero.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const tf = (el, x, y, s = 1, r = 0) => el.style.transform = `translate(-50%,-50%) translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) scale(${s.toFixed(4)}) rotate(${r.toFixed(2)}deg)`;

  const scroller = q("[data-hk-scroller]"), stage = q("[data-hk-stage]"), basket = q("[data-hk-basket]"), blob = q("[data-hk-blob]"),
        heroTop = q("[data-hk-top]"), heroBottom = q("[data-hk-bottom]"), sShirt = q("[data-hk-shirt]"), sCard = q("[data-hk-card]"),
        toggle = q("[data-hk-toggle]"), spacer = q("[data-hk-spacer]"), buyPanel = q("[data-hk-buy]"), tile = q("[data-hk-tile]");
  const motifs = qa("[data-hk-motif]").map((el, i) => ({ el, bx: +el.dataset.bx, by: +el.dataset.by, bw: +el.dataset.bw, br: +el.dataset.br, start: .06 + i * .01 }));
  const header = document.querySelector(".hk-header-section");
  const headH = () => header ? header.offsetHeight : 60;

  let L = {};
  function layout() {
    const HEAD = headH();
    stage.style.top = HEAD + "px";
    stage.style.height = `calc(100svh - ${HEAD}px)`;
    const W = stage.clientWidth, H = stage.clientHeight, narrow = W < 760;
    stage.dataset.hero = narrow ? "stack" : "split";
    heroBottom.style.top = ""; heroBottom.style.bottom = "";
    let bw, bh, by;
    const bx = 0;
    if (narrow) {
      const topH = heroTop.offsetHeight, botH = heroBottom.offsetHeight, g1 = 10, g2 = 16;
      bw = Math.min(W - 24, 520); bh = bw * 449 / 608;
      const maxBh = H - 32 - topH - botH - g1 - g2;
      if (bh > maxBh) { bh = Math.max(120, maxBh); bw = bh * 608 / 449; }
      const t0 = Math.max(12, (H - (topH + g1 + bh + g2 + botH)) / 2);
      heroTop.style.top = t0 + "px";
      by = t0 + topH + g1 + bh / 2 - H / 2;
      heroBottom.style.top = (t0 + topH + g1 + bh + g2) + "px";
      heroBottom.style.bottom = "auto";
    } else {
      const padT = 28, padB = 24;
      heroTop.style.top = padT + "px";
      heroBottom.style.bottom = padB + "px";
      const botEdge = H - padB - heroBottom.offsetHeight - 14;
      const line = heroTop.querySelector(".h1-big").offsetHeight;
      const areaTop = padT + line + 6, areaBot = botEdge - line - 6;
      heroTop.style.setProperty("--split-y", (areaBot + 6 - padT) + "px");
      bw = Math.max(200, Math.min(W - 32, 700, Math.max(150, areaBot - areaTop) * 608 / 449));
      bh = bw * 449 / 608;
      by = (areaTop + areaBot) / 2 - H / 2;
    }
    basket.style.width = bw + "px";

    let sw, sx, sy;
    if (narrow) {
      sw = Math.min(W - 8, H * .52 / (808 / 900));
      sx = 0; sy = -H / 2 + 8 + sw * (808 / 900) / 2;
    } else {
      const leftW = W * .54;
      sw = Math.min(leftW * .8, (H - 150) / (808 / 900), 620);
      sx = -W / 2 + leftW / 2 + 10; sy = -24;
    }
    const shH = sw * (808 / 900);
    sShirt.style.width = sw + "px";
    // Mit Hoodie liegen beide Teile nebeneinander im Korb, das Shirt links
    const multi = hero.dataset.multi === "1";
    const startScale = (multi ? Math.min(bw * .5, bh * .62 * 900 / 808) : Math.min(bw * .62, bh * .8 * 900 / 808)) / sw;
    const startY = by + (multi ? bw * .02 : bh * .01);
    const startX = multi ? bx - bw * .18 : bx;
    motifs.forEach(m => {
      m.el.style.width = bw * m.bw + "px";
      m.sx = bx + m.bx * bw; m.sy = by + m.by * bw;
      m.ex = m.sx * 1.7; m.ey = m.sy + (m.sy - by) * .6;
    });

    const animLen = H * .95;
    if (narrow) {
      const tileH = 8 + shH + 44;
      stage.style.marginBottom = "0";
      spacer.style.height = animLen + "px";
      if (buyPanel.parentNode === scroller) scroller.after(buyPanel);
      buyPanel.style.marginTop = -(H - tileH) + "px";
      tile.style.width = W + "px"; tile.style.height = tileH + "px";
    } else {
      stage.style.marginBottom = -H + "px";
      spacer.style.height = animLen + H * .22 + "px";
      if (buyPanel.parentNode !== scroller) scroller.appendChild(buyPanel);
      buyPanel.style.marginTop = "0";
      tile.style.width = W * .54 + "px"; tile.style.height = H + "px";
    }
    toggle.style.left = (W / 2 + sx) + "px";
    toggle.style.top = (H / 2 + sy + shH / 2 + 8) + "px";
    L = { W, H, bx, by, sx, sy, startScale, startX, startY, startR: multi ? -4 : -3, narrow, animLen, HEAD };
  }

  // Drehen per Maus/Finger und über „Vorne / Hinten“
  let drag = 0, dragT = 0;
  (() => {
    let sx = 0, start = 0, down = false;
    sShirt.addEventListener("pointerdown", e => { down = true; sx = e.clientX; start = dragT; });
    addEventListener("pointermove", e => { if (down) dragT = start + (e.clientX - sx) * .5; });
    addEventListener("pointerup", () => down = false);
    addEventListener("pointercancel", () => down = false);
  })();
  const vFront = q("[data-hk-front]"), vBack = q("[data-hk-back]");
  const totalT = () => 180 + dragT;
  vFront.onclick = () => { dragT = 360 * Math.round(totalT() / 360) - 180; };
  vBack.onclick = () => { dragT = 360 * Math.floor(totalT() / 360); };
  let shownBack = null;
  function syncToggle(total) {
    const d = ((total % 360) + 360) % 360, back = d > 90 && d < 270;
    if (back === shownBack) return;
    vFront.setAttribute("aria-pressed", String(!back)); vBack.setAttribute("aria-pressed", String(back)); shownBack = back;
  }

  function renderStage(p) {
    const { H, bx, by, sx, sy, startScale, startX, startY, startR } = L;
    const a = ease(clamp(p / .3));
    const u = ease(clamp((p - .04) / .5));
    const rot = ease(clamp((p - .45) / .4));
    const e = clamp((p - .8) / .2);
    heroTop.style.opacity = heroBottom.style.opacity = 1 - clamp(a * 1.6);
    heroTop.style.transform = `translate3d(0,${(-a * 50).toFixed(1)}px,0)`;
    heroBottom.style.transform = `translate3d(0,${(a * 50).toFixed(1)}px,0)`;
    heroBottom.style.pointerEvents = a > .5 ? "none" : "auto";
    tf(basket, bx, by + a * H * .9, 1 - a * .1, a * 6);
    basket.style.opacity = 1 - clamp((a - .6) / .4);
    tf(blob, lerp(bx, sx, u), lerp(by, sy, u), lerp(.55, 1, u), 0);
    tile.style.opacity = u;
    const lift = Math.sin(Math.PI * u) * -H * .05;
    tf(sShirt, lerp(startX, sx, u), lerp(startY, sy, u) + lift, lerp(startScale, 1, u), lerp(startR, 0, u));
    const total = rot * 180 + drag;
    sCard.style.transform = `rotateY(${total.toFixed(2)}deg)`;
    syncToggle(total);
    motifs.forEach(m => {
      const k = ease(clamp((p - m.start) / .34));
      tf(m.el, lerp(m.sx, m.ex, k), lerp(m.sy, m.ey, k), 1, m.br);
      m.el.style.opacity = 1 - k;
    });
    toggle.style.opacity = e;
    toggle.style.pointerEvents = e > .5 ? "auto" : "none";
  }

  // Kaufbereich: Artikel (Shirt / Hoodie), Größe, Preis, In den Warenkorb
  const groups = qa("[data-hk-group]");
  let active = groups.find(g => !g.hidden) || null;
  const mine = el => { const g = el.closest("[data-hk-group]"); return !g || g === active; };
  const sizeInputs = qa("[data-hk-size-input]");
  const selected = () => { const list = sizeInputs.filter(mine); return list.find(i => i.checked) || list[0]; };
  const addBtns = qa("[data-hk-add]"), barBtn = q("[data-hk-add-bar]"), buybar = q("[data-hk-buybar]");
  const curAdd = () => (active && active.querySelector("[data-hk-add]")) || addBtns[0];
  function syncSize() {
    const s = selected(); if (!s) return;
    qa("[data-hk-size-show]").filter(mine).forEach(el => el.textContent = s.dataset.size);
    if (s.dataset.price) qa("[data-hk-price]").filter(mine).forEach(el => el.textContent = s.dataset.price);
    if (barBtn) { const b = curAdd(); barBtn.disabled = !!(b && b.disabled); }
    if (window.history && history.replaceState && document.body.classList.contains("template-product")) {
      const url = new URL(location.href); url.searchParams.set("variant", s.value); history.replaceState({}, "", url);
    }
  }
  sizeInputs.forEach(i => i.addEventListener("change", syncSize));

  async function addToCart(btn) {
    const s = selected(); if (!s || !window.hkCart) return;
    btn.disabled = true;
    try { await window.hkCart.add(s.value, 1); } catch (_) {} finally { btn.disabled = false; }
  }
  addBtns.forEach(b => b.addEventListener("click", () => addToCart(b)));
  if (barBtn) barBtn.addEventListener("click", () => addToCart(barBtn));

  // Umschalter Shirt / Hoodie: tauscht Kaufbereich und Bilder, das Teil dreht sich einmal
  const picks = qa("[data-hk-pick]");
  const imgF = q("[data-hk-img-front]"), imgB = q("[data-hk-img-back]"), barTitle = q("[data-hk-bar-title]");
  function pick(k, spin) {
    const g = groups.find(x => x.dataset.hkGroup === k); if (!g || g === active) return;
    active = g;
    groups.forEach(x => { x.hidden = x !== g; });
    picks.forEach(b => { const on = b.dataset.hkPick === k; b.setAttribute("aria-checked", String(on)); b.tabIndex = on ? 0 : -1; });
    const t = g.dataset.title || "";
    if (imgF && g.dataset.front) { imgF.src = g.dataset.front; imgF.alt = `${t} – Vorderseite mit heimatkinner-Schriftzug`; }
    if (imgB && g.dataset.back) { imgB.src = g.dataset.back; imgB.alt = `${t} – Rückseite mit zwölf Emsland-Motiven in Stick-Optik`; }
    sShirt.setAttribute("aria-label", `${t}: vorne Schriftzug, hinten Motive. Ziehen zum Drehen.`);
    if (barTitle) barTitle.textContent = t;
    if (spin && !reduce) dragT += 360;
    syncSize();
  }
  picks.forEach(b => {
    b.addEventListener("click", () => pick(b.dataset.hkPick, true));
    b.addEventListener("keydown", e => {
      if (!/^Arrow/.test(e.key)) return;
      e.preventDefault();
      const i = picks.indexOf(b), n = picks[(i + (/Right|Down/.test(e.key) ? 1 : picks.length - 1)) % picks.length];
      n.focus(); pick(n.dataset.hkPick, true);
    });
  });
  // Bilder des zweiten Artikels vorladen, damit beim Umschalten nichts flackert
  if (groups.length > 1) addEventListener("load", () => groups.forEach(g => [g.dataset.front, g.dataset.back].forEach(u => { if (u) { const i = new Image(); i.src = u; } })));

  // Lieferdatum aus Werktagen berechnen
  (() => {
    const min = +hero.dataset.etaMin || 3, max = +hero.dataset.etaMax || 4;
    const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; } return d; };
    const f = d => d.toLocaleDateString("de-DE", { weekday: "short", day: "numeric", month: "numeric" });
    qa("[data-hk-eta]").forEach(el => el.textContent = `${f(add(min))} – ${f(add(max))}`);
  })();

  // „Jetzt kaufen“ und #shirt-Links springen dorthin, wo das Shirt gelandet ist
  // #hoodie wählt direkt den Hoodie (z. B. für Links aus Instagram)
  document.querySelectorAll('a[href="#shirt"], a[href$="/#shirt"], a[href="#hoodie"], a[href$="/#hoodie"]').forEach(link => link.addEventListener("click", e => {
    if (!scroller) return;
    const sameDoc = link.pathname === location.pathname || link.getAttribute("href").charAt(0) === "#";
    if (!sameDoc) return;
    e.preventDefault();
    if (link.hash === "#hoodie") pick("2", false);
    const top = scrollY + scroller.getBoundingClientRect().top - L.HEAD + L.animLen + 2;
    scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  }));

  let pS = 0, lastT = performance.now(), stageOn = true, barOn = null;
  new IntersectionObserver(es => es.forEach(en => { stageOn = en.isIntersecting; }), { rootMargin: "200px 0px" }).observe(scroller);
  const drawer = document.querySelector("[data-hk-drawer]");
  function frame(now) {
    const dt = Math.min(.05, (now - lastT) / 1000); lastT = now;
    const r = scroller.getBoundingClientRect();
    const scrolled = L.HEAD - r.top;
    const target = clamp(scrolled / L.animLen);
    pS += (target - pS) * (reduce ? 1 : 1 - Math.exp(-dt * 7));
    if (Math.abs(target - pS) < .0003) pS = target;
    drag += (dragT - drag) * (reduce ? 1 : 1 - Math.exp(-dt * 8));
    if (stageOn) renderStage(pS);
    const addBtn = curAdd();
    if (buybar && addBtn) {
      const ab = addBtn.getBoundingClientRect();
      const show = scrolled > L.animLen && (ab.bottom < L.HEAD || ab.top > innerHeight) && !(drawer && drawer.classList.contains("show"));
      if (show !== barOn) { buybar.classList.toggle("show", show); buybar.setAttribute("aria-hidden", String(!show)); barBtn.tabIndex = show ? 0 : -1; barOn = show; }
    }
    requestAnimationFrame(frame);
  }

  syncSize();
  addEventListener("resize", layout);
  if (location.hash === "#hoodie" && groups.length > 1) {
    pick("2", false);
    addEventListener("load", () => setTimeout(() => { layout(); scrollTo({ top: scrollY + scroller.getBoundingClientRect().top - L.HEAD + L.animLen + 2 }); }, 60));
  }
  if (document.fonts) document.fonts.ready.then(layout);
  layout();
  requestAnimationFrame(frame);
  // im Theme-Editor neu aufbauen, wenn der Abschnitt geändert wird
  document.addEventListener("shopify:section:load", e => { if (e.target.querySelector("[data-hk-hero]")) location.reload(); });
})();
